import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { trackHelpCenterEmailOverPhoneClick } from "@faire/web-api--source/events/helpCenter/click/emailOverPhone";

import { isPhoneInBusinessHours } from "../../Phone/isPhoneInBusinessHours";

export const trackEmailUsClickWhenPhoneInBusinessHours = (
  issueType: string,
  hasPhoneAccess: boolean
) => {
  if (!isPhoneInBusinessHours() || !hasPhoneAccess) {
    return;
  }
  const retailerToken = getRetailerToken() ?? "";
  const brandToken = getBrandToken() ?? "";
  trackHelpCenterEmailOverPhoneClick(retailerToken, brandToken, issueType);
};
